<template>
  <div class="executePlan-main">
    <Header title="执行计划"></Header>
    <van-sticky :offset-top="50">
      <van-tabs
        v-if="schoolCode == '10008'"
        v-model="activeName"
        type="line"
        sticky
        animated
        @change="tabChange"
      >
        <van-tab title="方案说明"></van-tab>
        <van-tab title="课程明细"></van-tab>
        <van-tab title="学分要求"></van-tab>
      </van-tabs>
      <van-tabs
        v-else
        v-model="activeName"
        type="line"
        sticky
        animated
        @change="tabChange"
      >
        <van-tab title="执行计划"></van-tab>
        <van-tab title="培养方案"></van-tab>
      </van-tabs>
    </van-sticky>
    <template v-if="schoolCode == '10008'">
      <template v-if="activeName == 1">
        <template v-if="activeName == 1">
          <div class="executePlan_select">
            <div class="sem-drop">
              <div @click="semPicker = true">
                <p>{{ this.semester }}</p>
                <i></i>
              </div>
            </div>
            <van-popup v-model="semPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="option1"
                @cancel="semPicker = false"
                @confirm="semesterChoose"
                :swipe-duration="500"
                :item-height="35"
              />
            </van-popup>
          </div>
        </template>
        <NOdata
          v-if="clList.length == 0 && isLoad"
          title="暂无执行计划~"
        ></NOdata>
        <div class="content_ executePlan" v-else>
          <div
            class="executePlan_list"
            v-for="(item, index) in clList"
            :key="index"
          >
            <h4>
              {{ item.COURSENAME }}
            </h4>
            <div>
              <div>
                <p>学分： {{ item.CREDIT }}</p>
                <p>考核方式： {{ item.EVALUATIONMODE }}</p>
              </div>
              <div>
                <p>学时： {{ item.TOTALHOURS }}</p>
                <p>是否考试： {{ item.WHETHERTOTEST }}</p>
              </div>
            </div>
            <p>课程属性: {{ item.COURSEATTRIBUTE }}</p>

            <p>课程编号: {{ item.COURSECODE }}</p>
            <p>开课单位： {{ item.COURSEUNITS }}</p>
          </div>
        </div>
      </template>
      <template v-if="activeName == 0">
        <div class="courseDetails">
          <div class="button">
            <van-button
              size="small"
              :class="{ 'courseDetails-button': true, primary: active == 0 }"
              @click="active = 0"
              >培养目标</van-button
            >
            <van-button v-if="schoolCode!='13008'"
              size="small"
              :class="{ 'courseDetails-button': true, primary: active == 1 }"
              @click="active = 1"
              >详细说明</van-button
            >
          </div>
          <article v-if="active == 0" v-html="detailList.target"></article>
          <article v-if="active == 1" v-html="detailList.explain"></article>
        </div>
      </template>
      <template v-if="activeName == 2">
        <xfyq />
      </template>
    </template>
    <template v-else>
      <template v-if="activeName == 0">
        <template v-if="activeName == 0">
          <div class="executePlan_select">
            <div class="sem-drop">
              <div @click="semPicker = true">
                <p>{{ this.semester }}</p>
                <i></i>
              </div>
            </div>
            <van-popup v-model="semPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="option1"
                @cancel="semPicker = false"
                @confirm="semesterChoose"
                :swipe-duration="500"
                :item-height="35"
              />
            </van-popup>
          </div>
        </template>
        <NOdata
          v-if="clList.length == 0 && isLoad"
          title="暂无执行计划~"
        ></NOdata>
        <div class="content_ executePlan" v-else>
          <div
            class="executePlan_list"
            v-for="(item, index) in clList"
            :key="index"
          >
            <h4>
              {{ item.COURSENAME }}
            </h4>
            <div>
              <div>
                <p>学分： {{ item.CREDIT }}</p>
                <p>考核方式： {{ item.EVALUATIONMODE }}</p>
              </div>
              <div>
                <p>学时： {{ item.TOTALHOURS }}</p>
                <p>是否考试： {{ item.WHETHERTOTEST }}</p>
              </div>
            </div>
            <p>课程属性: {{ item.COURSEATTRIBUTE }}</p>

            <p>课程编号: {{ item.COURSECODE }}</p>
            <p>开课单位： {{ item.COURSEUNITS }}</p>
          </div>
        </div>
      </template>
      <template v-if="activeName == 1">
        <div class="courseDetails">
          <div class="button">
            <van-button
              size="small"
              :class="{ 'courseDetails-button': true, primary: active == 0 }"
              @click="active = 0"
              >培养目标</van-button
            >
            <van-button v-if="schoolCode!='13008'"
              size="small"
              :class="{ 'courseDetails-button': true, primary: active == 1 }"
              @click="active = 1"
              >详细说明</van-button
            >
          </div>
          <article v-if="active == 0" v-html="detailList.target"></article>
          <article v-if="active == 1" v-html="detailList.explain"></article>
        </div>
      </template>
      <template v-if="activeName == 2">
        <xfyq />
      </template>
    </template>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
import xfyq from "./xfyq";
export default {
  data() {
    return {
      value1: 0,
      clList: [],
      semPicker: false,
      semester: "学年学期",
      option1: [
        {
          text: "学年学期",
          value: 0,
          index: "",
        },
      ],
      isLoad: false,
      activeName: 0,
      active: 0,
      detailList: {},
      schoolCode: ''
    };
  },
  components: {
    xfyq,
  },
  methods: {
    async semesterChoose(e, val) {
      this.semPicker = false;
      this.semester = e.text;
      const params = {
        semester: this.semester == "学年学期" ? "" : this.semester,
      };
      const res = await Api.executionPlan(params);
      this.clList = res.data;
    },
    async getTerm() {
      const res = await Api.getCurrentTerm();
      this.semester = res.data[0].semesterId;
    },
    async getSemList() {
      let concatList = [];
      const res = await Api.getSemesterList();
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: item.semesterName,
          value: index + 1,
          index: item.semesterId,
        };
      });
      this.option1 = this.option1.concat(concatList);
    },
    async getPlan() {
      const res = await Api.executionPlan();
      this.clList = res.data;
      this.isLoad = true;
    },
    tabChange(activeName) {
      if (activeName == 0) {
        this.getPlan();
      }
      if (activeName == 1) {
        this.getList();
      }
    },
    // 获取培养目标和详细说明
    async getList() {
      const res = await Api.targetAndExplain();
      if (res.data[0]) {
        this.detailList = res.data[0];
      }
    },
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getTerm();
    this.getSemList();
    this.getPlan();
  },
};
</script>

<style lang="less" scoped>
.executePlan_select {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  // border-bottom: 1px solid @attendance-border-color-6;
  .sem-drop {
    > div {
      display: flex;
      align-items: center;
      color: @attendance-color-2;
      font-size: 14px;
      i {
        background: url(../../../../static/img/Triangle.png) no-repeat center;
        width: 10px;
        height: 10px;
        background-size: 10px 8px;
        margin-left: 5px;
      }
    }
  }
  select {
    background: none;
    border: 0;
    outline: 0;
  }
  /deep/.van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
    color: @attendance-color-1;
    font-weight: 600;
  }
  /deep/.van-dropdown-menu__title--active {
    color: @attendance-color-2;
  }
  /deep/.van-popup {
    max-height: 40%;
  }
  /deep/.van-hairline--top-bottom:after,
  .van-hairline-unset--top-bottom:after {
    border-width: 0;
  }
}
.executePlan {
  margin: 0 15px;
  .executePlan_list {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    &:first-of-type {
      margin-top: 10px;
    }
    > div {
      display: flex;
      justify-content: space-between;
      width: 100%;
      > div {
        width: 45%;
      }
    }
    h4 {
      text-align: left;
      margin-bottom: 4px;
      color: @attendance-color-8;
      font-size: 16px;
      line-height: 22px;
    }
    p {
      color: @attendance-color-2;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 2px;
    }
  }
}
.courseDetails {
  padding: 1rem 1.25rem;
  height: 100%;
  background-color: #fff;
  .button {
    margin-bottom: 10px;
    .courseDetails-button {
      width: 80px;
      height: 32px;
      border-radius: 16px !important;
      font-size: 14px;
      color: #505d9c;
      background: #f2f2f4;
      &.primary {
        background: rgba(121, 100, 255, 0.15);
        color: #7964ff;
      }
    }
  }
}
</style>
<style lang="less">
.executePlan-main {
  background-color: #f2f2f4;
  height: 100%;
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: @attendance-color-8 !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 100%;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: @attendance-color-2;
      letter-spacing: 0;
      text-align: center;
    }
    .van-tabs__line {
      background-color: @attendance-background-color-1 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Cultivate/executePlan.vue